import { Component, inject } from '@angular/core';
import { CacTableComponent, table } from '@controladad/ng-base';
import { AttributeApiService, AuthStore, cacTableIdCol, dashJoin, openAttributeDialog } from '@core';
import { AttributeEntity, AttributeSetEntity } from '@models';

@Component({
  selector: 'lib-attributes',
  imports: [CacTableComponent],
  templateUrl: './attributes.component.html',
  styleUrl: './attributes.component.scss',
})
export class AttributesComponent {
  private readonly attributeApi = inject(AttributeApiService);
  private readonly authStore = inject(AuthStore);

  table = table({
    itemsFn: this.attributeApi.getAdapter(),
    view: {
      itemName: 'Attribute',
    },
    columns: {
      id: cacTableIdCol(),
      name: {
        label: 'Name (EN - AR)',
        transform: dashJoin,
      },
      priority: { label: 'Priority' },
      sets: {
        label: 'Sets',
        transform: dashJoin,
      },
    },
    actions: [
      {
        type: 'icon' as const,
        content: 'edit',
        action: (item: AttributeEntity, event) =>
          openAttributeDialog(
            this.attributeApi,
            item.id,
          ),
      },
      ...(!this.authStore.isRestrictedAdmin() ? [{
        type: 'icon' as const,
        content: 'trash',
        action: (item: AttributeEntity) =>
          dialog$.deletePrompt(false, { itemName: item.name.english }).action(() => this.attributeApi.delete(item.id)),
      }] : []),
    ],
    events: {
      add: () => openAttributeDialog(
        this.attributeApi,
        undefined,
      )
    },
  });
}
